import React, {
  useMemo, useState, useLayoutEffect, useEffect, useCallback,
} from 'react';
import { useParams } from 'react-router';
import { createUseStyles } from 'react-jss';
import { useConfig } from '../../hooks/Configurator';
import { useSessionTimeout } from '../../hooks/useSessionTimeout';
import { useNavigation } from '../../hooks/useNavigation';
import routes from '../../routes';
import { bbAnalytics } from '../../helpers/analytics/setup/analytics.service.handler';

const useStyle = createUseStyles({
  iframe: {
    height: window.innerHeight - 68,
  },
});

const Item = () => {
  const [ready, setReady] = useState(false);
  const { title } = useParams();
  const items = useConfig(({ bbGeneralOptions }) => bbGeneralOptions.itemList);
  const item = useMemo(() => items.find((i) => i.title === title), [title, items]);
  const { iframe } = useStyle();
  const navigation = useNavigation();
  const { ItemPageTimeout } = useConfig(({ bbGeneralOptions }) => bbGeneralOptions.timeouts);

  const leave = useCallback(() => {
    bbAnalytics.triggerEventTrack('autoRefresh', title, 'Item');
    navigation.replace(routes.Splash);
  }, [navigation, title]);

  const timer = useSessionTimeout(ItemPageTimeout * 1000, leave);

  useEffect(() => {
    if (ready) {
      if (!window.location.hostname.includes('localhost')) {
        document.domain = 'jrni.com';
      }

      const iframeElement = document.getElementById('iframe').contentWindow;

      window.onmessage = ({ data }) => {
        const { type } = data;

        switch (type) {
          case 'VKM_REQUEST_PERMISSION': {
            const grantPermission = {
              type: 'VKM_PERMISSION_GRANTED',
            };

            iframeElement.postMessage(grantPermission, '*');
            break;
          }

          case 'VKM_ACTIVITY_DETECTED': {
            timer.activate();
            break;
          }

          default:
            break;
        }
      };
    }
    return () => {
      timer.reset();
    };
  }, [ready, timer]);

  useLayoutEffect(() => {
    setReady(true);
  }, []);


  if (!item || !ready) return false;

  return <iframe src={item.url} className={iframe} width="100%" title={item.title} id="iframe" />;
};


export default Item;
